var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cart-btn bg-none ml-2 headerIcon"},[_c('cartSvg'),(_vm.quantity != 0)?_c('span',{staticClass:"rounded-circle bg-color-themeRed text-white fontsize12 weight-bold"},[_vm._v(" "+_vm._s(_vm.quantity))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }